const AMPLITUDE_EVENT_VALUES = {
    BLUETOOTH_MODE: 'Bluetooth',
    USB_MODE: 'USB',
    UNKNOWN: 'Unknown',
    PARING_ERROR: 'App could not find an IQOS device',
    CONNECTING_ERROR: 'IoT connection error',
    LOCATE_MY_DEVICE_ERROR: 'Vibration command failed',
    ILLUMINATION_50: '50%',
    ILLUMINATION_100: '100%',
    VIBRATION_CUSTOM: 'Custom',
    VIBRATION_OFF: 'Off',
    SMART_GESTURES_ON: 'On',
    SMART_GESTURES_OFF: 'Off',
    AUTO_START_ON: 'On',
    AUTO_START_OFF: 'Off',
    FLEX_PUFF_ON: 'On',
    FLEX_PUFF_OFF: 'Off',
    FLEX_BATTERY_PAUSE_ON: 'On',
    FLEX_BATTERY_PAUSE_OFF: 'Off',
    FLEX_BATTERY_ECO: 'Eco',
    FLEX_BATTERY_PERFORMANCE: 'Performance',
    VAPE_CLOUD_SIZE_REGULAR: 'Regular',
    VAPE_CLOUD_SIZE_REDUCED: 'Reduced',
    RESPONSIVE_DRAW_VIVACE: 'Vivace',
    RESPONSIVE_DRAW_BUBBLY: 'Bubbly',
    RESPONSIVE_DRAW_CRESCENDO: 'Crescendo',
    RESPONSIVE_DRAW_STACCATO: 'Staccato',
    RESPONSIVE_DRAW_SIREN: 'Siren',
    RESPONSIVE_DRAW_OFF: 'Off',
    DEVICE_LOCKED: 'Locked',
    DEVICE_UNLOCKED: 'Unlocked',
    VAPING_SESSION_SECONDS: 'Seconds',
    VAPING_SESSION_PUFFS: 'Puffs',
    VAPING_SESSION_OFF: 'OFF',
    TRADE_IN_DEVICE_SETTINGS_1: 'Device settings 1',
    TRADE_IN_DEVICE_SETTINGS_2: 'Device settings 2',
    GENERAL_REGISTRATION_ERROR: 'General registration error (DCE2)',
    FWU_DEVICE_IN_SBL_ALERT: 'Device in SBL alert',
    FWU_DEVICE_SETTINGS_AUTO_CHECK: 'Device settings. Automated detection',
    FWU_ADVANCED_DIAGNOSTICS_RESULT: 'Advanced diagnostics result',
    FWU_DEVICE_SETTINGS_MANUAL_CHECK: 'Device settings. Manual detection',
    FWU_DEVICE_UPDATE_FAILED: 'Device update failed',
    FWU_DEVICE_CONNECTION_LOST: 'Device connection lost',
    FWU_DEVICE_RESET_FAILED: 'Device reset failed',
    CONNECT_CARE_NO_ERRORS_FOUND: 'CC No errors found',
    CONNECT_CARE_SCENARIO_M1: 'CC Scenario M1',
    CONNECT_CARE_SCENARIO_M2: 'CC Scenario M2',
    CONNECT_CARE_SCENARIO_M3: 'CC Scenario M3',
    CONNECT_CARE_SCENARIO_M4: 'CC Scenario M4',
    AD_SCENARIO_1: 'AD Scenario 1',
    AD_SCENARIO_2: 'AD Scenario 2',
    AD_SCENARIO_3: 'AD Scenario 3',
    AD_SCENARIO_FW: 'AD Scenario FW and Eligibility check flow',
    AD_SCENARIO_NO_ERRORS: 'AD No errors found',
    USAGE_CHECK_COMPATIBILITY: 'Usage Check Compatibility',
    USAGE_LEARN_MORE: 'Usage Learn More',
    LEVIA_CHECK_COMPATIBILITY: 'Check Compatibility',
    LEVIA_LEARN_MORE: 'Learn More',
};

export default AMPLITUDE_EVENT_VALUES;
